import { React } from '@/vendor'

const TelLink = ({ number }) => {
	return <a href={`tel:+1${number.replace(/\D/g, '')}`}>{number}</a>
}

export default TelLink
